module.exports = __webpack_public_path__ + "img/hr-pumpjack-horsehead.aadff97d.png";